import { render } from "./ListFinished.vue?vue&type=template&id=624556b2"
import script from "./ListFinished.vue?vue&type=script&lang=js"
export * from "./ListFinished.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__